import React from "react";
import { Routes, Route } from "react-router-dom";
import Login from "./views/Login";
import { AuthProvider } from "./context/AuthContext";
import AddCampaign from "./views/AddCampaign";
import FullLayout from "./layouts/FullLayout";
import Users from "./views/Users";
import ForgotPassword from "./views/ForgotPassword";
import CaseDetails from "./views/case/CaseDetails";
import NewPasswordCard from "./views/NewPasswordCard";
import MyFunds from "./views/MyFunds";
import { LoaderProvider } from "./context/LoaderContext";
import { SidebarProvider } from "./context/SidebarContext";
import Dashboard from "./views/Dashboard";
import AddCase from "./views/AddCase";
import DraftCases from "./views/AddCase/DraftCases";
import CaseView from "v2/case/CaseView";
import NewCases from "v2/case-list/New";
import Approved from "v2/case-list/Approved";
import Rejected from "v2/case-list/Rejected";
import Beneficiary from "pages/beneficiary";



const App = () => {

  return (
    <SidebarProvider>
      <LoaderProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/my-fund" element={<FullLayout Component={MyFunds} />} />
          <Route path="/user/reset-password/" element={<NewPasswordCard />} />
          {/* <Route  path="/user/reset-password/:token" element={<NewPasswordCard />}  /> */}
        </Routes>
        <Beneficiary />
        {/* Protected routes */}
        <AuthProvider>
          <Routes>
            <Route path="/" element={<NewCases />} />
            <Route path="/case/approved" element={<Approved />} />
            <Route path="/case/rejected" element={<Rejected />} />
            <Route path="/case/add" element={<AddCase />} />
            <Route path="/case/add/drafts" element={<DraftCases />} />
            <Route path="/case/:id" element={<CaseView />} />
            <Route path="/case/:id/details" element={<CaseDetails />} />
            <Route path="/add-campaign" element={<FullLayout Component={AddCampaign} />} />
            <Route path="/users" element={<FullLayout Component={Users} />} />
            <Route path="/case-details" element={<CaseDetails />} />
            <Route path="/dashboard" element={<Dashboard />} />
          </Routes>
        </AuthProvider>
      </LoaderProvider>
    </SidebarProvider>
  );
};

export default App;

